import styled from 'styled-components';
import theme from '../theme';

export const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${theme.colors.background};
  font-family: ${theme.typography.fontFamily};
`;

export const MainArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-left: ${({ $collapsed }) => $collapsed ? theme.layout.sidebarCollapsed : theme.layout.sidebarWidth};
  transition: margin-left ${theme.transitions.normal};

  ${theme.media.tablet} {
    margin-left: 0;
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  padding: ${theme.layout.contentPadding};
  overflow-y: auto;
  overflow-x: hidden;
  max-width: ${theme.layout.contentMaxWidth};
  width: 100%;
  box-sizing: border-box;

  ${theme.media.tablet} {
    padding: ${theme.layout.contentPaddingMobile};
  }
`;
